<template>
  <b-modal
      id="feedback-removal-tool"
      centered
      :title="$t('pages.feedbacks.removal_modal.title')"
      title-class="font-18"
      size="md"
      :ok-disabled="disable"
      :ok-title="$t('common.ok')"
      :cancel-title="$t('common.cancel')"
  >
    <div>
      <div class="mt-4">
        <div class="row justify-content-center my-2">
          <div class="col-sm-6 col-8 img-fluid">
            <div>
              <img src="@/assets/images/feedback_removal.svg" alt class="img-fluid"/>
            </div>
          </div>
        </div>
      </div>
      <b-card-body>
        <b-alert show
                 variant="info"
                 class="text-muted mt-1 mb-5">
          <i class="mdi mdi-alert-circle-outline me-2"></i>
          {{ $t('pages.feedbacks.removal_modal.info') }}
        </b-alert>
        <form class="form-horizontal">
          <b-form-group
              class="mb-3"
              label-cols-sm="3"
              label-cols-lg="3"
              :label="$t('pages.feedbacks.removal_modal.star')"
              label-for="star"
          >
            <b-form-select v-model="selectedStar"
                           id="star"
                           class="form-control"
                           :options="starOptions"/>
          </b-form-group>
          <b-form-group
              id="example-date-time"
              label-class="mb-3"
              label-cols-sm="3"
              label-cols-lg="3"
              :label="$t('pages.feedbacks.removal_modal.status')"
              label-for="status"
          >
            <div class="form-check form-switch form-switch-md mt-1">
              <input
                  v-model="selectedStatus"
                  class="form-check-input"
                  type="checkbox"
              />
            </div>
          </b-form-group>
        </form>
      </b-card-body>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "FeedbackRemovalToolModal",
  data() {
    return {
      starOptions: [
        {
          text: this.$t('pages.feedbacks.removal_modal.star_option', {star: 1}),
          value: 1
        },
        {
          text: this.$t('pages.feedbacks.removal_modal.star_option_below', {star: 2}),
          value: 2
        },
        {
          text: this.$t('pages.feedbacks.removal_modal.star_option_below', {star: 3}),
          value: 3
        }
      ],
      selectedStar: 3,
      selectedStatus: false,
      disable: true
    }
  }
}
</script>

<style scoped>

</style>